import React, { createContext, useContext, useRef, useState } from 'react';

type FormContextType = {
  registerSubmit: (submitFn: () => void) => void;
  triggerSubmit: () => Promise<void>;
  isModalOpen: boolean;
  setModalOpen: (open: boolean) => void;
};

const FormContext = createContext<FormContextType | undefined>(undefined);

export const ProfileCreationFormProvider = ({ children }: { children: React.ReactNode }) => {
  const submitFnRef = useRef<(() => any) | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const registerSubmit = (submitFn: () => any) => {
    submitFnRef.current = submitFn;
  };

  const triggerSubmit = async () => {
    await submitFnRef.current?.();
  };

  const handleSetModalOpen = (open: boolean) => {
    setIsModalOpen(open);
  };

  return (
    <FormContext.Provider value={{ registerSubmit, triggerSubmit, isModalOpen, setModalOpen: handleSetModalOpen }}>
      {children}
    </FormContext.Provider>
  );
};

export const useProfileCreationFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useProfileCreationFormContext must be used within a ProfileCreationFormProvider');
  }
  return context;
};
